module.exports = __webpack_public_path__ + "img/intermediate-message-throw-event.ac432d96.svg";